module.exports = __webpack_public_path__ + "static/OpenSans-SemiBoldItalic-b5737e9f09a97bd17faac1f83bc377e9.woff2";